var table_viewer_default = {
  "viewMode": "XTpQR",
  "editMode": "tp3BU",
  "container": "_5YjUI",
  "cell": "VauXe"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
